import React, { useState } from 'react';
import './App.css';
import ParkingEligibilityForm from './ParkingEligibilityForm';

// Cloudflare Worker API endpoint
const WORKER_API_URL = process.env.REACT_APP_WORKER_URL || 'http://localhost:8787';

function App() {
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (licensePlate) => {
    setError('');
    setResult(null);
    setLoading(true);

    try {
      const response = await fetch(`${WORKER_API_URL}/api/verify-parking`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ licensePlate }),
      });

      const data = await response.json();

      if (response.ok) {
        setResult(data);
      } else {
        setError(data.error || 'An error occurred while processing your request.');
      }
    } catch (error) {
      setError('Unable to connect to the verification service. Please try again.');
      console.error('API call error:', error);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-100 py-6 flex flex-col justify-center sm:py-12">
      <div className="relative py-3 sm:max-w-xl sm:mx-auto">
        <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-light-blue-500 shadow-lg transform -skew-y-6 sm:skew-y-0 sm:-rotate-6 sm:rounded-3xl"></div>
        <div className="relative px-4 py-10 bg-white shadow-lg sm:rounded-3xl sm:p-20">
          <div className="max-w-md mx-auto">
            <h1 className="text-3xl font-extrabold text-gray-900 text-center">Check to see if your car fits the garage</h1>
            <ParkingEligibilityForm 
              onSubmit={handleSubmit}
              result={result}
              error={error}
              loading={loading}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;